import styled from "@emotion/styled";
import { useState } from "react";
import { BsFillCaretDownFill as Down } from "react-icons/bs";

const DateFilter = (props: any) => {
  const text = props.text ? props.text : "Date Range";
  const [show, setShow] = useState(false);
  const [start, setStart] = useState<any>("");
  const [end, setEnd] = useState<any>("");
  const onChange = props.onChange
    ? props.onChange
    : (arg: any) => {
        console.log(arg);
      };
  const handleApply = () => {
    onChange({ start, end });
    setShow(false);
  };
  return (
    <Wrapper>
      {show && <div onClick={() => setShow(!show)} className="cancel"></div>}
      <span onClick={() => setShow(!show)}>
        {text}
        <span>
          <Down />
        </span>
      </span>

      {show && (
        <div className="drop">
          <label>
            <span>From</span>
            <input
              type="date"
              placeholder="Start Date"
              value={start}
              onChange={(e) => setStart(e.target.value)}
            />
          </label>
          
          <label>
            <span>To</span>
            <input
              type="date"
              value={end}
              onChange={(e: any) => setEnd(e.target.value)}
              placeholder="End Date"
            />
          </label>
          <StyledBtn onClick={handleApply}>Apply</StyledBtn>
        </div>
      )}
    </Wrapper>
  );
};

export default DateFilter;

const WrapperDiv = (props: any) => {
  const children = props.children;
  return <div {...props}>{children}</div>;
};

const Wrapper = styled(WrapperDiv)`
  width: fit-content;
  position: relative;
  display: inline-block;
  & > div.cancel {
    position: fixed;
    z-index: 1000;
    width: 90vw;
    height: 90vw;
    top: 0;
    left: 0;
    background-color: transparent !important;
  }
  & > div.drop {
    position: absolute;
    z-index: 1001;
    right: 0;
    padding: 20px;
    top: 50px;
    width: 200px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 8px;
  }
  & > div.drop > label {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  & > div.drop > label > input {
    width: 100%;
    padding: 12px;
    border-radius: 6px;
    border: 1px solid #eee;
  }
  & > span {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 15px 20px;
    border-radius: 6px;
    background-color: ${(props) =>
      props.bg ? props.bg : "rgb(226, 228, 233)"};
    color: ${(props) => (props.color ? props.color : "#222")};
    border: 1px solid
      ${(props) => (props.border ? props.border : "rgb(226, 228, 233)")};
    cursor: pointer;
  }
`;

const StyledBtn = styled.button`
  outline: none;
  border: none;
  padding: 12px 0;
  text-align: center;
  border-radius: 6px;
  color: var(--white-color);
  background-color: rgb(10, 80, 10);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
